<!DOCTYPE html>
<html lang="en">

<head>
  <title> Volume List </title>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-Content-Type-Options" content="nosniff">
</head>

<body>

  <p-tabView class="fr-tabview__header__custom">
    <p-tabPanel>
       <div class="flex-box m-t-70"> 
      <div class="fr-flex__col-12"> 
      <div class="fr-flex__container">
        <div class="fr-flex__col-8">
        </div>
        <div class="fr-flex__col-4">
          <button *ngIf="ExportPrivilege" class="btn btn-outline-primary pull-right" [disabled]="isChecked" (click)="exportContractVolumes()"><i class="pi pi-download"></i> Export</button>
        </div>
    </div>
  </div>
</div>
      <div class="fr-flex__col-12">
        <div class="inside-grid-pad">
          <p-table id="contractVolumeListTableName" class="primeng-table-custom custom-cells_draft-invoices"
            [resizableColumns]="true" columnResizeMode="expand" [value]="_contractVolumeListData" [paginator]="true"
            [scrollable]="true" [rows]="10" styleClass="p-datatable-striped p-datatable-gridlines"
            [(selection)]="selectedVolumes" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Entries"
            [rowsPerPageOptions]="[10, 20, 50, 100, 200]">
            <ng-template pTemplate="header">
              <tr>
                <th id="contractVolumeListTHCheckbox" pFrozenColumn class="first-child-width">
                  <p-tableHeaderCheckbox (click)="CheckboxEnabled()"></p-tableHeaderCheckbox>
                </th>
                <th id="conVolumeistVolumeMonth" pFrozenColumn pSortableColumn="volumeMonth" pResizableColumn
                  pInputText>Month <p-sortIcon field="volumeMonth"></p-sortIcon></th>
                <th id="conVolumeListVolumeInvoice" pSortableColumn="invoiceValue" pResizableColumn>Invoice Amount
                  <p-sortIcon field="invoiceValue"> </p-sortIcon></th>
                <th id="conVolumeListVolumeStatus" pSortableColumn="volumeStatus" pResizableColumn pInputText>Volume Update
                  Status <p-sortIcon field="volumeStatus"></p-sortIcon></th>
                <th id="conVolumeModified" pSortableColumn="volumeModified" pResizableColumn>Modified By
                  <p-sortIcon field="volumeModified"></p-sortIcon></th>
                <th id="conVolumeListEdit" *ngIf="editPrivilege" class="last-child-width">Edit</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-volume>
              <tr>
                <td id="contractVolumeListTDCheckbox" pFrozenColumn>
                  <p-tableCheckbox [value]="volume" (click)="CheckboxEnabled()"></p-tableCheckbox>
                </td>
                <td routerLinkActive="active">
                  <a id="contractVolumeListHyperLink" class="table-active-link" (click)="viewVolume(volume)"
                    *ngIf="viewPrivilege; else disabledLink"> {{ volume.volumeDate | date:'MMMM yyyy' }} </a>
                  <ng-template #disabledLink>
                    {{ volume.volumeDate | date:'MMMM yyyy'}}
                  </ng-template>
                </td>
                <td>{{ volume.InvoiceValue || 'NA' }}</td>
                <td>{{volume.statusName}}</td>
                <td>{{ volume.updatedByName || '--' }}</td>
                
                <td id="contractVolumeListEdit" *ngIf="editPrivilege" class="grid-icon-center">
                <span [pTooltip]="volume.InvoiceValue == null ? 'No Invoices Added for this Month' : 
                      (volume.statusName === 'Not Applicable' ? 'Not Applicable' : undefined)" tooltipPosition="top">
                 <i class="pi pi-pencil" [ngStyle]="{
                 'opacity': (volume.InvoiceValue == null || volume.statusName === 'Complete' || volume.statusName === 'Not Applicable') ? '0.5' : '1',
                 'cursor': (volume.InvoiceValue == null || volume.statusName === 'Complete' || volume.statusName === 'Not Applicable') ? 'not-allowed' : 'pointer'
                  }" (click)="volume.InvoiceValue != null && volume.statusName !== 'Complete' && volume.statusName !== 'Not Applicable' && editVolume(volume)">
               </i>
               </span>
              </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10" class="text-center"> No Records</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>


</body>

</html>
